import React, {useEffect, useState} from "react"
import Accordion from 'react-bootstrap/Accordion';
import './pillar-card.scss'
import {MdKeyboardArrowDown} from "react-icons/md";
import {BiCheckDouble} from "react-icons/bi";
import {Modal, Spin} from 'antd';
import {Controller, useForm} from "react-hook-form";
import {PillarsService} from "../../../../services/pillars-api.service";
import ThemeButton from "../../../common/theme-button/ThemeButton";
import {CheckboxEmpty, CheckboxFill} from "../../../../../assets/icons/defaultIcons";
import DescriptionField from "../../../common/description-field/DescriptionField";
import {useUser} from "../../../../providers/UserContext";
import {checkEmptySpaces} from "../../../../utils/patterns";
import {LoadingOutlined} from '@ant-design/icons';
import {useNavigate} from "react-router-dom";
import PillarChecboxComponent from "./PillarCheckboxComponent";

export default function PillarCard7({heading, icon , options, hasInputText , setPillarLoader, GetPillarsData , selectedItem}) {
    const[loader,setLoader] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalContent , setModalContent] = useState({})
    const [updateCheckLength , setUpdateCheckLength] = useState(false)
    const {pointUpdate , setPointUpdate} = useUser();
    const navigate = useNavigate()
    const [antDesignOptions, setAntDesignOptions] = useState(options.map(question => ({
        label: question.name,
        value: question.mainQuestionId,
        status: question.status,
        mainQuestionId: question.mainQuestionId,
        questions: question.questions,
        content: question?.content ? question?.content : []
    })));

    const [totalOptions, setTotalOptions] = useState(antDesignOptions.length);
    const [checkedList, setCheckedList] = useState([]);
    const [allChecked, setAllChecked] = useState(false);
    const [activeKey, setActiveKey] = useState("0");  // Keeping the first item always open
    const [formattedHeading, setFormattedHeading] = useState([]);

    const handleSelect = (eventKey) => {
        // Prevent collapsing by always setting activeKey back to "0"
        setActiveKey("0");
    };

    useEffect(() => {
        setTotalOptions(antDesignOptions.length);
        updateCheckedStates();
        // checkAllChecked();
    }, []);



    function updateCheckedStates() {
        const checked = antDesignOptions.filter(opt => opt.status).map(opt => opt.value);
        setCheckedList(checked);
        // console.log('checkedList', checkedList);
        // setAllChecked(checked.length === totalOptions);
    }


    const handleAntOptions = (item, status) =>{
        const updatedOptions = antDesignOptions.map(opt => {
            if (opt.value === item.value) {
                return { ...opt, status };
            }
            return opt;
        });

        setAntDesignOptions(updatedOptions);  // Update the state with the modified options


        // console.log('rjunnign', previousCheckedList)
        updateChecksStatus(item,status)
        setPointUpdate(!pointUpdate);
        return updatedOptions.find(pillar => pillar.value == item.value);
    }

    function updateChecksStatus(item , status) {
        let previousCheckedList = checkedList;
        if(status && !previousCheckedList.includes(item.value)){
            previousCheckedList.push(item.value);
        } else {
            let checkedListIndex = previousCheckedList.indexOf(item);
            previousCheckedList.splice(checkedListIndex, 1);
        }
        setCheckedList(previousCheckedList);
    }

    const updateLastChecksStatus = (value, status) => {
        setCheckedList(prevCheckedList => {
            if (status) {
                if(!checkedList.includes(value)) {
                    return [...prevCheckedList, value];
                }
                return prevCheckedList;
            } else {
                return prevCheckedList.filter(val => val !== value);
            }
        });
    };

    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors},
        control,
        clearErrors,
        watch
    } = useForm({
        mode: 'onChange',
    })

    function openQuestionModal(item) {
        setModalContent(item);
        setValue('text', item.status && item.content.length > 0 ? item.content[0].text : '');
        setIsModalVisible(true);
    }

    function updateStatusToTrue(mainQuestionId, text) {
        setAntDesignOptions(currentOptions =>
            currentOptions.map(opt => {
                if (opt.mainQuestionId === mainQuestionId) { // Always update the specified entry
                    if (opt.status == false) {
                        updateLastChecksStatus(opt.value ,true)
                    }

                    const updatedOpt = { ...opt, status: true, content: [{ ...opt.content[0], text }] };
                    return updatedOpt;
                }
                return opt;
            })
        );

        // updateCheckedStates();
    }

    function checkAllChecked() {
        // Calculate if all options are checked
        const allChecked = antDesignOptions.every(opt => opt.status);
        setAllChecked(allChecked);
    }

    const onSubmit = async (data) => {
        setLoader(true);
        let payload = {
            status: true,
            content: [{ label: modalContent.label, text: data.text }]
        };
        const response = await PillarsService.updateCurrentDatePillars(modalContent.mainQuestionId, payload);
        if (response?.data?.data?.status) {
            // Now update the checkbox status as the submission was successful.
            updateStatusToTrue(modalContent.mainQuestionId, data.text);
            setPointUpdate(!pointUpdate);

            setIsModalVisible(false);
        }
        setLoader(false);
        reset();
    };

    // Utility function to transform label with line breaks
    function transformLabelWithLineBreaks(label) {
        // Replace '\\n' with '\n' to handle literal sequences, then split and map
        return label.replace(/\\n/g, '\n').split('\n').map((part, index, array) => (
            <React.Fragment key={index}>
                {part}
                {index < array.length - 1 && <br />}
            </React.Fragment>
        ));
    }

    return(
        <div className={'pillar-card'}>
            <Accordion activeKey={activeKey} onSelect={handleSelect}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <div className={`pillar-header ${checkedList.length === totalOptions ? 'all-checked' : ''}`}>
                            <div>
                                <h4><span className={'icon-circle'}><img height={35} width={35} src={icon} /></span> {heading}</h4>
                            </div>
                            <div className={'options'}>
                                <span className={`counter ${checkedList.length === totalOptions ? 'all-checked' : ''}`}>
                                    { (checkedList.length === totalOptions) && <BiCheckDouble />}
                                    {checkedList.length} <i>/ {totalOptions}</i>
                                </span>
                                <div className={'icon'}>
                                    <MdKeyboardArrowDown />
                                </div>
                            </div>
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        {
                            !hasInputText ?
                                <div className={`checkkbox-div ${loader ? 'disabled ' : ''}`}>
                                    {
                                        antDesignOptions.map((item,index)=>{
                                            return(
                                              <PillarChecboxComponent item={item} index={index} setUpdateCheckLength={setUpdateCheckLength} updateCheckLength={updateCheckLength} handleAntOptions={handleAntOptions} />
                                            )
                                        })
                                    }
                                </div>
                                :
                                <div className={`checkkbox-div ${loader ? 'disabled ' : ''}`}>
                                    {
                                        antDesignOptions.map((item,index)=>{
                                            return(
                                                <div className={`checkbox-box ${item.status && 'checked'}`} key={index}
                                                     {...(loader ? {} : { onClick: () =>  openQuestionModal(item) })}>
                                                    {
                                                        loader ?  <Spin className={'check-spinner'} indicator={<LoadingOutlined spin />} /> :
                                                            <span> {item.status ?<CheckboxFill/> : <CheckboxEmpty/>  }</span>


                                                    }

                                                    <span className={''}>{item.label}</span>
                                                </div>
                                            )
                                        })
                                    }

                                </div>
                        }
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <Modal
                title={modalContent.label}
                visible={isModalVisible}
                centered
                footer={false}
                wrapClassName='theme-modals pillar-modal'
                onCancel={() => {
                    setIsModalVisible(false);
                    reset();
                }}
                width={550}
                maskClosable={false}
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='dfields'>
                        <Controller
                            name='text'
                            control={control}
                            defaultValue=''
                            rules={{ required: true, maxLength: 1000 ,validate: checkEmptySpaces }}
                            render={({ field }) => (
                                <DescriptionField
                                    placeholder='Write your text here'
                                    type='text'
                                    label={transformLabelWithLineBreaks(modalContent.questions[0])}
                                    field={field}
                                    errors={errors.text}
                                    autoSize={{ minRows: 12, maxRows: 12 }}
                                />
                            )}
                        />
                    </div>
                    <div className={'view-archive'}>
                        <p onClick={()=>{navigate('/pillar/archives')}}>View Archives</p>
                    </div>
                    <div className='mt-30'>
                        <ThemeButton
                            text='Submit'
                            type='submit'
                            className='btn-light-lg'
                            loader={loader}
                        />
                    </div>
                </form>
            </Modal>
        </div>
    )
}